import {
  FeeItem,
  FeeListItem,
  FeeSubTypeEnum,
  FeeTransactionTypeEnum,
  FeeType,
  FeeTypeEnum,
} from '../../fees/types';
import { PspPartnerPaymentType } from '../../bank-and-psp/types';

export const defaultFeesList: FeeType[] = [
  {
    type: FeeTypeEnum.TRANSACTION,
    subType: PspPartnerPaymentType.BACS,
    list: [],
  },
  {
    type: FeeTypeEnum.TRANSACTION,
    subType: PspPartnerPaymentType.FASTER_PAYMENT,
    list: [],
  },
  {
    type: FeeTypeEnum.TRANSACTION,
    subType: PspPartnerPaymentType.SEPA_SCT,
    list: [],
  },
  {
    type: FeeTypeEnum.TRANSACTION,
    subType: PspPartnerPaymentType.SEPA_SCT_INST,
    list: [],
  },
  {
    type: FeeTypeEnum.TRANSACTION,
    subType: PspPartnerPaymentType.SWIFT,
    list: [],
  },
  {
    type: FeeTypeEnum.TRANSACTION,
    subType: PspPartnerPaymentType.TARGET_2,
    list: [],
  },
  {
    type: FeeTypeEnum.TRANSACTION,
    subType: PspPartnerPaymentType.FEDWIRE,
    list: [],
  },
  {
    type: FeeTypeEnum.TRANSACTION,
    subType: PspPartnerPaymentType.CRYPTO_ASSET_PAYMENT,
    list: [],
  },
  {
    type: FeeTypeEnum.TRANSACTION,
    subType: PspPartnerPaymentType.CASH_OVER_COUNTER,
    list: [],
  },
  {
    type: FeeTypeEnum.REGULAR,
    subType: FeeSubTypeEnum.HIGH_BALANCE,
    list: [],
  },
  {
    type: FeeTypeEnum.REGULAR,
    subType: FeeSubTypeEnum.INACTIVITY,
    list: [],
  },
  {
    type: FeeTypeEnum.REGULAR,
    subType: FeeSubTypeEnum.REGULAR,
    list: [],
  },
  {
    type: FeeTypeEnum.MANUAL,
    list: [],
  },

  {
    type: FeeTypeEnum.INTERNAL,
    list: [],
  },
];

const getFeeTypeName = (type: string) => {
  let typeName;

  switch (type) {
    case FeeTypeEnum.INTERNAL:
      typeName = 'Internal';
      break;
    case FeeTypeEnum.MANUAL:
      typeName = 'Manual';
      break;
    case FeeTypeEnum.REGULAR:
      typeName = 'Regular';
      break;
    case FeeTypeEnum.TRANSACTION:
      typeName = 'Transaction';
      break;
    default:
      typeName = type;
      break;
  }

  return typeName;
};

const getSubTypeName = (subType: string) => {
  let subTypeName;

  switch (subType) {
    case FeeSubTypeEnum.HIGH_BALANCE:
      subTypeName = 'High-Balance fee';
      break;
    case FeeSubTypeEnum.INACTIVITY:
      subTypeName = 'Account inactivity fee';
      break;
    case FeeSubTypeEnum.REGULAR:
      subTypeName = 'Regular package fee';
      break;
    case PspPartnerPaymentType.BACS:
      subTypeName = 'BACS';
      break;
    case PspPartnerPaymentType.FASTER_PAYMENT:
      subTypeName = 'Faster Payment';
      break;
    case PspPartnerPaymentType.SEPA_SCT:
      subTypeName = 'SEPA SCT';
      break;
    case PspPartnerPaymentType.SEPA_SCT_INST:
      subTypeName = 'SEPA SCT INST';
      break;
    case PspPartnerPaymentType.SWIFT:
      subTypeName = 'SWIFT';
      break;
    case PspPartnerPaymentType.TARGET_2:
      subTypeName = 'TARGET 2';
      break;
    case PspPartnerPaymentType.FEDWIRE:
      subTypeName = 'Fedwire';
      break;
    case PspPartnerPaymentType.CRYPTO_ASSET_PAYMENT:
      subTypeName = 'Crypto Asset Payment';
      break;
    default:
      break;
  }

  return subTypeName;
};

export const formatFeeList = ({
  data,
  item,
}: {
  data: FeeItem;
  item: FeeType;
}) => {
  let result = { ...item };

  let nextList: FeeListItem[] = [];

  if (result.list) {
    nextList = ([] as FeeListItem[]).concat(result.list);
  }

  if (data.feeTransactionType === FeeTransactionTypeEnum.INTERNAL) {
    nextList.push({
      name: data.name,
      value: data.id,
    });
    result.list = nextList;
  } else if (data.feeType === result.type) {
    if (data.paymentType || data.regularFeeSubType) {
      if (
        (data.paymentType && data.paymentType === result?.subType) ||
        (data.regularFeeSubType && data.regularFeeSubType === result?.subType)
      ) {
        let feeList: FeeListItem[] = [];

        if (result?.list) {
          feeList = ([] as FeeListItem[]).concat(result.list);
        }

        if (feeList.find((fee) => fee.id === data.id)) {
          feeList = feeList.map((fee) => {
            let feeResult = { ...fee };

            if (data.id === feeResult.id) {
              feeResult = {
                name: data.name,
                value: data.id,
              };
            }

            return feeResult;
          });
        } else {
          feeList.push({
            name: data.name,
            value: data.id,
          });
        }

        result = {
          ...result,
          list: feeList,
        };
      }
    } else if (nextList.find((fee) => fee.id === data.id)) {
      nextList = nextList.map((fee) => {
        let feeResult = { ...fee };

        if (data.id === feeResult.id) {
          feeResult = {
            name: data.name,
            value: data.id,
          };
        }

        return feeResult;
      });

      result.list = nextList;
    } else {
      nextList.push({
        name: data.name,
        value: data.id,
      });

      result.list = nextList;
    }
  }

  let subTypeName;

  if (item?.subType) {
    subTypeName = getSubTypeName(result?.subType as string);

    if (!subTypeName) {
      const subTypeArray = result?.subType?.split('_');

      subTypeName = subTypeArray
        ?.map((type) => `${type.charAt(0)}${type?.slice(1)?.toLowerCase()}`)
        .join(' ');
    }
  }

  result.title = `${getFeeTypeName(result.type as string)} ${
    subTypeName || 'fee'
  }`;

  return result;
};
